import React from 'react';
import { Card, Typography, Button, Space, Skeleton, Grid } from 'antd';
import TemplateUploadCTA from './TemplateUploadCTA';
import { DeleteOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import Markdown from '../Markdown';

const { Text, Paragraph } = Typography;

export default function NoteTypePreviewPanel({
  selectedNoteTypeSlug,
  selectedTemplate,
  noteTypePreview,
  previewLoading,
  onUse,
  onCustomize,
  isTemplatesTab = false,
  onDeleteTemplate,
  templatesEmpty = false,
}) {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const hasSelection = Boolean(selectedNoteTypeSlug || selectedTemplate);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
      <Card
        style={{ height: '100%', border: 'none', boxShadow: 'none' }}
        bordered={false}
        styles={{ body: { height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden', minHeight: 0 } }}
      >
        <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden' }}>
          {!hasSelection && (
            templatesEmpty && isTemplatesTab ? (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', marginTop: '40px', minHeight: '300px' }}>
                <img src="https://img.icons8.com/plasticine/100/template.png" alt="template-empty" />
                <Paragraph type="secondary" style={{ marginTop: 12, textAlign: 'center' }}>
                  {t('note_templates.empty_state')}
                </Paragraph>
                {screens.xs && (
                  <div style={{ marginTop: 8, display: 'flex', justifyContent: 'center' }}>
                    <TemplateUploadCTA onNewTemplate={onCustomize} />
                  </div>
                )}
              </div>
            ) : (
              <Paragraph type="secondary" style={{ textAlign: 'center', marginTop: '40px' }}>
                {t('note_type_selector.select_placeholder')}
              </Paragraph>
            )
          )}

          {(selectedNoteTypeSlug || selectedTemplate) && (() => {
            const isNoteType = Boolean(selectedNoteTypeSlug);
            const markdownContent = isNoteType
              ? noteTypePreview?.getMarkdownPreview()
              : selectedTemplate?.getContent();

            return (
              <Space direction="vertical" size="small" style={{ display: 'flex' }}>
                {isNoteType && previewLoading && (
                  <div style={{ marginTop: '16px' }}>
                    <Skeleton active paragraph={{ rows: 4 }} />
                  </div>
                )}

                {markdownContent ? (
                  <div style={{ marginTop: '4px' }}>
                    <div 
                      style={{ 
                        padding: '16px', 
                        backgroundColor: '#fafafa', 
                        borderRadius: '6px',
                        border: '1px solid #e8e8e8'
                      }}
                    >
                      <Markdown content={markdownContent} />
                    </div>
                  </div>
                ) : (
                  <Paragraph type="secondary" style={{ whiteSpace: 'pre-wrap' }}>—</Paragraph>
                )}
              </Space>
            );
          })()}

        </div>
        {hasSelection && (
          <div style={{ paddingTop: 30, paddingBottom: 0, marginBottom: -20, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
            <div>
              {selectedTemplate && isTemplatesTab && (
                <Button
                  data-testid="delete-template-button"
                  icon={<DeleteOutlined />}
                  size="small"
                  type="text"
                  onClick={onDeleteTemplate}
                />
              )}
            </div>
            <div style={{ display: 'flex', gap: 15 }}>
              <Button onClick={onCustomize}>{selectedTemplate ? t('note_type_selector.edit_button') : t('note_type_selector.customize_button')}</Button>
              <Button type="primary" onClick={onUse}>{t('note_type_selector.use_button')}</Button>
            </div>
          </div>
        )}

        
      </Card>
    </div>
  );
}


